import axios from "axios";

const PROD_BASE = "https://backend-myalfa.vercel.app";
const API_BASE = process.env.REACT_APP_API_BASE || PROD_BASE;

const httpClient = axios.create({
  baseURL: API_BASE,
});

httpClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Redirect hardcoded production URLs to the configured base (useful for local dev)
  if (config.url && config.url.startsWith(PROD_BASE)) {
    config.url = config.url.replace(PROD_BASE, API_BASE);
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && error.response?.data?.expired === true) {
      localStorage.removeItem("token");
      localStorage.removeItem("utilisateur");
      localStorage.removeItem("user");
      window.dispatchEvent(new CustomEvent("session-expired"));
    }
    return Promise.reject(error);
  }
);

// Wrapper fetch qui injecte automatiquement le JWT
const authFetch = async (url, options = {}) => {
  const token = localStorage.getItem("token");
  const resolvedUrl = url.startsWith(PROD_BASE)
    ? url.replace(PROD_BASE, API_BASE)
    : url;
  const response = await fetch(resolvedUrl, {
    ...options,
    headers: {
      ...options.headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (response.status === 401) {
    try {
      const cloned = response.clone();
      const data = await cloned.json();
      if (data?.expired === true) {
        localStorage.removeItem("token");
        localStorage.removeItem("utilisateur");
        localStorage.removeItem("user");
        window.dispatchEvent(new CustomEvent("session-expired"));
      }
    } catch (_) {}
  }
  return response;
};

export { httpClient, authFetch, API_BASE };
